export default "/images/open_head.png?25504df4af75c65a5ec205004a77ed6e";